import { Text } from "@radix-ui/themes";
import { type ReactNode } from "react";

export type CollapsedPaneLabelProps = {
  collapsed: boolean;
  onExpand: () => void;
  ariaLabel: string;
  testId: string;
  labelRender: () => ReactNode;
};

const EXPAND_TRANSITION =
  "width 300ms cubic-bezier(0.16,1,0.3,1), opacity 300ms cubic-bezier(0.16,1,0.3,1), background-color 150ms ease";

export function CollapsedPaneLabel({
  collapsed,
  onExpand,
  ariaLabel,
  testId,
  labelRender,
}: CollapsedPaneLabelProps) {
  return (
    <button
      onClick={onExpand}
      style={{
        width: collapsed ? 32 : 0,
        opacity: collapsed ? 1 : 0,
        overflow: "hidden",
        flexShrink: 0,
        pointerEvents: collapsed ? "auto" : "none",
        transition: EXPAND_TRANSITION,
      }}
      className={`box-border flex h-full cursor-pointer items-center justify-center bg-puntt-neutral-gray-2 hover:bg-puntt-neutral-gray-3 ${
        collapsed ? "border-r border-puntt-neutral-gray-6" : "border-0"
      }`}
      aria-label={ariaLabel}
      aria-hidden={!collapsed}
      tabIndex={collapsed ? 0 : -1}
      data-testid={testId}
    >
      <Text
        size="1"
        weight="medium"
        className="whitespace-nowrap uppercase tracking-wide text-puntt-neutral-gray-9"
        style={{
          writingMode: "vertical-rl",
          transform: "rotate(180deg)",
        }}
      >
        {labelRender()}
      </Text>
    </button>
  );
}
